export const wishlistFn = () => {
  const wishlist = document.querySelector(".navbar-wishlist__count");
  if (!wishlist || !window.sebaNavbarAjax) return;

  const ajaxUrl = window.sebaNavbarAjax.ajaxUrl;
  let controller, timeout;

  function updateCount() {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      if (controller) controller.abort();
      controller = new AbortController();

      fetch(ajaxUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'action=yith_wcwl_update_wishlist_count',
        credentials: 'same-origin',
        signal: controller.signal,
      })
        .then((res) => res.json())
        .then((response) => {
          wishlist.textContent = response.count;
        })
        .catch(() => {});
    }, 100);
  }

  updateCount();

  document.addEventListener('added_to_wishlist', updateCount);
  document.addEventListener('removed_from_wishlist', updateCount);
};
